import { Route, Routes, Navigate } from "react-router-dom";
import { routes } from "../../router/index";
import Layout from './Layout';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Layout />}>
        {routes.map((i) => (
          <Route key={i.path} path={i.path} element={<i.element />} />
        ))}
      </Route>
      <Route path='/*' element={<Navigate to='/en/' replace />} />
    </Routes>
  );
};

export default AppRouter;
